import React, { Component } from "react";
import { Input, Select } from "antd";

const { Option } = Select;

class SeatInput extends Component {
  static getDerivedStateFromProps(nextProps) {
    // Should be a controlled component.
    if ("value" in nextProps) {
      return {
        ...(nextProps.value || {}),
      };
    }
    return null;
  }

  constructor(props) {
    super(props);

    const value = props.value || {};
    this.state = {
      num: value.num || 0,
      type: value.type || "0",
    };
  }

  handleNumChange = e => {
    const num = parseInt(e.target.value || 0, 10);
    if (Number.isNaN(num)) {
      return;
    }
    if (!("value" in this.props)) {
      this.setState({ num });
    }
    this.setState({ num });
    this.triggerChange({ num });
  };

  handleTypeChange = type => {
    if (!("value" in this.props)) {
      this.setState({ type });
    }
    this.setState({ type });
    this.triggerChange({ type });
  };

  triggerChange = changedValue => {
    // Should provide an event to pass value to Form.
    const {onChange} = this.props;
    if (onChange) {
      onChange({ ...this.state, ...changedValue});
    }
  };

  render() {
    const { size } = this.props;
    const {state} = this;
    return (
      <span>
        <Input
          type="text"
          size={size}
          value={state.num}
          onChange={this.handleNumChange}
          style={{ width: "65%", marginRight: "3%" }}
        />
        <Select
          value={state.type}
          size={size}
          style={{ width: "32%" }}
          onChange={this.handleTypeChange}
        >
          <Option value="0">个</Option>
          <Option value="1">列</Option>
          <Option value="2">行</Option>
        </Select>
      </span>
    );
  }
}
export default SeatInput;



// WEBPACK FOOTER //
// ./src/components/incubator/seat/SeatInput.js